module.exports = __webpack_public_path__ + "img/BibleStudyBG.30a223e8.jpg";